import { some } from "lodash";
import locale from "@bonliva-crm/locale";

type Day = { form: { dirty: boolean } };

/**
 * The warning shown before the week changes status or is sent on while a day still holds
 * edits (CRMDEV-7588). Those edits are not saved for the user, and the reload after the
 * action drops them. Null when nothing is unsaved.
 */
export function unsavedDaysWarning(days: Day[] | null | undefined): string | null {
  return some(days, (day) => day.form.dirty) ? locale.UnsavedTimesLost : null;
}
